import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hero is-small has-background-blue" }
const _hoisted_2 = { class: "hero-body" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "columns level" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "column" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "has-text-white" }, "NUESTROS MEDIOS DE CONTACTO INMEDIATO")
], -1)
const _hoisted_6 = { class: "column" }
const _hoisted_7 = { class: "columns is-mobile level" }
const _hoisted_8 = { class: "column is-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "column is-10" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "has-text-white" }, [
    /*#__PURE__*/_createTextVNode(" ¿Necesitas ayuda? Llámanos"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("+52 (55) 1335-0671 ")
  ])
], -1)
const _hoisted_10 = { class: "column" }
const _hoisted_11 = { class: "columns is-mobile level" }
const _hoisted_12 = { class: "column is-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "column is-10" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "has-text-white" }, "Chatea con nosotros")
], -1)
const _hoisted_14 = { class: "column" }
const _hoisted_15 = { class: "columns is-mobile level" }
const _hoisted_16 = { class: "column is-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "column is-10" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "has-text-white" }, [
    /*#__PURE__*/_createTextVNode(" Escríbenos"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("contacto@alfapacksolutions.com ")
  ])
], -1)

import SvgIcon from "@jamescoyle/vue-icon";
import { mdiPhone, mdiWhatsapp, mdiEmail } from "@mdi/js";

export default /*#__PURE__*/_defineComponent({
  __name: 'ContactMedia',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_unref(SvgIcon), {
                  type: "mdi",
                  path: _unref(mdiPhone),
                  style: {"color":"white"}
                }, null, 8, ["path"])
              ]),
              _hoisted_9
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_unref(SvgIcon), {
                  type: "mdi",
                  path: _unref(mdiWhatsapp),
                  style: {"color":"white"}
                }, null, 8, ["path"])
              ]),
              _hoisted_13
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_unref(SvgIcon), {
                  type: "mdi",
                  path: _unref(mdiEmail),
                  style: {"color":"white"}
                }, null, 8, ["path"])
              ]),
              _hoisted_17
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})